import type { PropsWithChildren } from "react";
import { ThemeProvider } from "@mui/material";
import CSSBaseLine from "@mui/material/CssBaseline";
import customTheme from "@style/theme";

const ThemeWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <ThemeProvider theme={customTheme()}>
      <CSSBaseLine />
      {children}
    </ThemeProvider>
  );
};

export default ThemeWrapper;
